<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">
            {{ $t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.userAccessRightsTranslation }}
          </h6>

          <nav class="dashboard_menu">
<!--            <div class="nav nav-tabs" role="tablist">-->
<!--              <router-link :to="{ name: 'dashboardPersonalInfo' }" class="nav-item nav-link active" role="tab">-->
<!--                {{ $t('dashboard.tabs.info') }}-->
<!--              </router-link>-->
<!--              <router-link :to="{ name: 'dashboardSubmittedTimeSheets' }" class="nav-item nav-link" role="tab">-->
<!--                {{ $t('dashboard.tabs.submitted_time_sheets') }}-->
<!--              </router-link>-->
<!--            </div>-->
          </nav>
          <div class="row mt-4">
            <div class="col-lg-6">
              <h6 class="mt-5">{{ $t('dashboard.customer_information') }}</h6>
              <div class="row mt-3">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <CardInfo :label="$t('general.active_customers')" :value="infoData?.countActiveCoaching?.total"/>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <CardInfo :label="$t('general.new_customers')" :value="infoData?.countNewCoaching?.total"/>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <h6 class="mt-5">Vollzeitäquivalent</h6>
              <div class="row mt-3">
                <div class="col-lg-6 col-md-8 col-sm-8">
                  <CardInfo :label="'Vollzeitäquivalent'" :value="infoData?.fullTimeWorkingEquivalent"/>
                </div>
              </div>
            </div>
          </div>

          <div class="element-box mb-5 mt-4">
            <h6>Gehalt nach Mitarbeitertyp</h6>
            <VueApexCharts width="100%" :options="chartOptionsBar" :series="seriesSalaryEmployee"/>
          </div>

          <div class="element-box mb-5 mt-4">
            <div class="d-flex justify-content-between mb-4">
              <h6>Neue Mitarbeiter</h6>
              <button class="btn btn-primary" @click="downloadFile('/dashboard/hr/new-users-excel-export', undefined)">
                Neue Mitarbeiter Excelexport
              </button>
            </div>
            <VueApexCharts width="100%" :options="chartOptionsArea" :series="seriesNewEmployee"/>
          </div>

          <div class="element-box mb-5">
            <h6>Erste-Hilfe-Schulung</h6>
            <div class="table-responsive mt-4">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Mitarbeiternr</th>
                  <th>Vorname</th>
                  <th>Nachname</th>
                  <th>Erste-Hilfe-Schulung</th>
                  <th>Rechte</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="user of infoData?.firstAidTraining?.users" v-bind:key="user?.firstName">
                  <td>
                    {{ user?.employeeNumber }}
                  </td>
                  <td>
                    {{ user?.firstName }}
                  </td>
                  <td>
                    {{ user?.lastName }}
                  </td>
                  <td>
                    {{ user?.firstAidTraining }}
                  </td>
                  <td>
                    {{ user?.accessRights }}
                  </td>
                  <td style="text-align: right">
                    <router-link
                        :to="{ name: 'userForm', params: { id: user?.id } }"
                        class="btn btn-primary">
                      Einzelcoaching
                    </router-link>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="element-box mb-2">
            <h6>Brandschutzschulung</h6>
            <div class="table-responsive mt-4">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Mitarbeiternr</th>
                  <th>Vorname</th>
                  <th>Nachname</th>
                  <th>Letzte Brandschutzschulung</th>
                  <th>Rechte</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="user of infoData?.fireProtectionTraining?.users" v-bind:key="user?.firstName">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
      <FormSidebar>
        <template #top>
          <h6 class="element-header">
            Sidebar Infos
          </h6>
        </template>

        <div class="element-box mt-4">
          <h6 class="mb-3">{{ $t('general.birthdays') }}</h6>
          <div v-for="user of infoData?.todayBirthdays" v-bind:key="user?.fullName"
               class="d-flex justify-content-between">
            <span>{{ user?.fullName }}</span>
            <span>{{ user?.date }}</span>
          </div>
        </div>

        <div class="element-box">
          <h6 class="mb-3">{{ $t('dashboard.anniversaries') }}</h6>
          <div v-for="user of infoData?.jubileesOfEmployees" v-bind:key="user?.lastName"
               class="d-flex justify-content-between">
            <span>{{ user?.firstName + ' ' + user?.lastName }}</span>
            <span>{{ user?.startingDate + ' - ' + user?.years }}</span>
          </div>
        </div>

        <div class="element-box">
          <h6 class="mb-3">{{ $t('dashboard.number_employees_internal') }}</h6>
          <div v-for="user of infoData?.countUsersByType?.internal" v-bind:key="user?.name"
               class="d-flex justify-content-between">
            <span>{{ user?.name }}</span>
            <span>{{ user?.count }}</span>
          </div>
        </div>

        <div class="element-box">
          <h6 class="mb-3">{{ $t('dashboard.number_employees_external') }}</h6>
          <div v-for="user of infoData?.countUsersByType?.external" v-bind:key="user?.name"
               class="d-flex justify-content-between">
            <span>{{ user?.name }}</span>
            <span>{{ user?.count }}</span>
          </div>
        </div>
      </FormSidebar>
    </div>
  </div>
</template>

<script setup>
import dashboardHRService from '@/api/Dashboard/HR';
import CardInfo from '@/components/card/CardInfo.vue';
import FormSidebar from '@/components/FormSidebar.vue';
import { ErrorToast } from '@/components/VueToast';
import { downloadFile } from '@/shared/functions';
import { optionsChartArea, optionsChartBar } from '@/shared/utils/apex';
import { piniaUserStore } from '@/store/piniaUserStore';
import { onMounted, ref } from 'vue';
import VueApexCharts from 'vue3-apexcharts';

const chartOptionsArea     = ref(optionsChartArea);
const chartOptionsBar      = ref(optionsChartBar);
const seriesSalaryEmployee = ref([]);
const seriesNewEmployee    = ref([]);

const infoData = ref({});

async function getInfoData() {
  try {
    const { data } = await dashboardHRService.getInfoData();
    infoData.value = data.data;

    chartOptionsBar.value      = {
      ...optionsChartBar,
      chart: {
        height: 550,
      },
      xaxis: {
        categories: data.data.salariesByEmployeeType?.map((user) => user.type + ' ' + user?.count),
      },
      legend: {
        show: false,
      },
      colors: [
        'rgba(67, 173, 78, 0.6)',
      ],
    };
    chartOptionsArea.value     = {
      ...optionsChartArea,
      chart: {
        height: 550,
      },
      colors: [
        'rgba(67, 173, 78, 0.6)',
        'rgba(75, 192, 192, 0.6)',
      ],
      xaxis: {
        categories: data.data.countNewUserPerMonth.map((month) => month?.monthName),
      },
      legend: {
        position: 'top',
      },
    };
    seriesSalaryEmployee.value = [ { data: data.data.salariesByEmployeeType?.map((user) => +user.salary) } ];
    seriesNewEmployee.value    = [ {
      name: 'Intern',
      data: data.data.countNewUserPerMonth.map((month) => month?.intern),
    }, { name: 'Extern', data: data.data.countNewUserPerMonth.map((month) => month?.extern) } ];

  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(() => {
  getInfoData();
});
</script>

<style scoped>
</style>